module.exports = __webpack_public_path__ + "static/media/nr.34ed2f24.svg";